import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '@/components/ui/Logo';

/**
 * Brand link used on public (non-authenticated) pages.
 * Wraps the TrésoPilot logo + wordmark and links back to the public landing page.
 */
export default function BrandLink({ to, className = '', ...logoProps }) {
  // Public landing page is served at '/'.
  // We keep '/landing' as a valid route, but prefer root for branding.
  const href = to || '/';
  return (
    <Link
      to={href}
      className={`inline-flex items-center rounded-xl focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2 ${className}`}
      aria-label="Aller à l'accueil TrésoPilot"
    >
      <Logo {...logoProps} />
    </Link>
  );
}
